import type { ThemePreference } from "@minket/ui/hooks/theme";

export const themeLabels: Record<ThemePreference, string> = {
  system: "System",
  light: "Light",
  dark: "Dark",
};
